import { createApiEffect } from '@/features/api/common/create-api-effect'

export const updateStudentByIdFx = createApiEffect<{ id: string; body: any }, any>({
  requestMapper: ({ id, body }) => ({
    method: 'PATCH',
    url: `/api/user-app/student/${id}/`,
    body,
  }),
})
